import React from "react";
import { Col, Row } from "react-bootstrap";

export default function MonoText_Frameless_H({ item, isSub, isForHeightCalculation }) {
  const hitRange = isForHeightCalculation
    ? item.scale.ranges[0]
    : item.scale.ranges.find((range) => range.start <= Number(item.score) && Number(item.score) <= range.end);

  return (
    <Row
      style={{
        height: Number(item.height),
      }}
      className={"mx-0 " + (!hitRange && "d-none")}
    >
      <Col>
        {item.scale?.isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: hitRange?.text }} />
        ) : (
          <div
            style={{
              fontSize: "10pt",
              fontFamily: "Arial, sans-serif",
              textAlign: "left",
              position: "relative",
              paddingLeft: "15px",
            }}
          >
            <span
              style={{
                position: "absolute",
                left: "0",
                color: "black",
                fontWeight: "bold",
              }}
            >
              •
            </span>
            {hitRange?.text}
          </div>
        )}
      </Col>
    </Row>
  );
}
